<template>
  <div class="layout" ref="layout">
    <el-container style="height:100%;overflow: hidden;">
      <el-header class="header-col el-header">
        <div class="header-content">
          <p class="header-tit">红色教育服务中心运营管理后台</p>
          <div class="user-info">
            <el-dropdown placement="bottom" >
              <div class="el-dropdown-link">
<!--                <img src="" alt="" />-->
                <p class="header-username">{{ userInfo.nickname}}</p>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
<!--                <el-dropdown-item command="info">个人信息</el-dropdown-item>-->
                <el-dropdown-item  ><span @click="logout()">退出登录</span></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-header>


      <el-container>
        <!-- 侧边导航栏 -->

        <el-col :span="3"  style="height:100%">
          <el-menu
              default-active="2"
              class="el-menu-vertical-demo"
              background-color="#3d4a59"
              text-color="#fff"
              active-text-color="#ffd04b"  style="min-width:200px;height:100%">
            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-user"></i>
                <span>用户管理</span>
              </template>
              <el-menu-item-group >
                <router-link to="/admin/hsjy/admin/users" >
                  <el-menu-item index="1-1">
                    查询用户
                  </el-menu-item>
                </router-link>
                <router-link to="/admin/hsjy/admin/usersdept">
                  <el-menu-item index="1-2">部门管理</el-menu-item>
                </router-link>

<!--                <el-menu-item index="1-3">权限管理</el-menu-item>-->
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-document"></i>
                <span>文章管理</span>
              </template>
              <el-menu-item-group >
                <router-link to="/admin/hsjy/admin/articleadd">
                  <el-menu-item index="2-1" >
                    文章发布
                  </el-menu-item>
                </router-link>
                <router-link to="/admin/hsjy/admin/articleman">
                  <el-menu-item index="2-2">
                    文章管理
                  </el-menu-item>
                </router-link>
                <router-link to="/admin/hsjy/admin/articleColumn">
                  <el-menu-item index="2-3">栏目管理</el-menu-item>
                </router-link>
                <router-link to="/admin/hsjy/admin/articleVideo">
                  <el-menu-item index="2-4">视频管理</el-menu-item>
                </router-link>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-wallet"></i>
                <span slot="title">展陈管理</span>
              </template>
              <el-menu-item-group>
                <router-link to="/admin/hsjy/admin/displayadmin">
                  <el-menu-item index="3-1">
                    展陈管理
                  </el-menu-item>
                </router-link>
              </el-menu-item-group>
            </el-submenu>



            <router-link to="/admin/hsjy/admin/culturaladmin">
              <el-menu-item index="4">
                <i class="el-icon-box"></i>
                <span slot="title">文物管理</span>
              </el-menu-item>
            </router-link>

            <router-link to="/admin/hsjy/admin/yizhiadmin">
              <el-menu-item index="5">
                <i class="el-icon-s-finance"></i>
                <span slot="title">基地管理</span>
              </el-menu-item>
            </router-link>

            <router-link to="/admin/hsjy/admin/yjjadmin">
              <el-menu-item index="6">
                <i class="el-icon-s-home"></i>
                <span slot="title">义勇军纪念馆</span>
              </el-menu-item>
            </router-link>
          </el-menu>
        </el-col>

        <el-container>
          <el-main class="el-main" >
            <router-view></router-view>
          </el-main >
          <el-footer class="el-footer">

          </el-footer>
        </el-container>

      </el-container>

    </el-container>

  </div>
</template>

<script>



export default {
  name: "HomeAdmin",
  components: {

  },
  data(){
    return {
      userInfo: {}
    }
  },
  methods:{
    logout:function(){
      console.log(1111111)
      localStorage.removeItem('userInfo');
      this.$router.replace({
        path:'/admin/hsjy/login'
      })
    }
  },
  mounted() {
  this.$refs.layout.style = 'height:'+ window.innerHeight + 'px';
  this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  }
}
</script>


<style  scoped>
html, body, #app, .el-container {
  height: 100%;
}
/*头部*/
.header-col{
  background: #2c3e50;
  height: 60px;
  padding:0 40px;
}
.el-header, .el-footer {
  color: #333;
  text-align: left;
  line-height: 60px;
}
.header-content {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
}
.header-tit {
  font-size: 18px;
  font-weight: bold;
}
.header-username {
  font-size: 16px;
  color: #fff;
}
.user-info {
  display: flex;
  align-items: center;
}
.el-dropdown-link {
  display: flex;
  align-items: center;
}
.el-dropdown-link img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  margin-right: 10px;
}
/*侧边栏*/
.el-main {
  overflow-y: scroll;
}
.router-link-active {
  text-decoration: none;
  color: rgb(255, 208, 75);
}
a {
  text-decoration: none;
  color: #fff;
}
.el-footer{

}
</style>
